'use es6';

import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import I18n from 'I18n';
import UIButton from 'UIComponents/button/UIButton';
import UISection from 'UIComponents/section/UISection';
export default createReactClass({
  displayName: "ReviewListZeroState",
  propTypes: {
    isAbleToReview: PropTypes.bool.isRequired,
    triggerReviewModal: PropTypes.func.isRequired
  },
  renderFooter: function renderFooter(triggerReviewModal) {
    return React.createElement(UIButton, {
      className: "m-top-2",
      onClick: triggerReviewModal,
      use: "primary"
    }, I18n.text('goodDetails.reviewList.reviewThisProduct'));
  },
  render: function render() {
    var _this$props = this.props,
        isAbleToReview = _this$props.isAbleToReview,
        triggerReviewModal = _this$props.triggerReviewModal;
    return React.createElement(UISection, {
      className: "text-center",
      use: "island"
    }, React.createElement("p", {
      className: "is--heading-5 m-bottom-2"
    }, I18n.text('goodDetails.reviewList.zeroState.header')), React.createElement("p", null, I18n.text('goodDetails.reviewList.zeroState.description')), isAbleToReview ? this.renderFooter(triggerReviewModal) : null);
  }
});